<style type="text/css" media="screen">
.pre-image{
	height: 142px;
	/*width: 142px;*/
	border-radius: 10px;
}
</style>

<template>
	<div class="pt-4">
		<v-form ref="add_retailer_form"  lazy-validation >
			<v-row justify="start" class="custome-form">
				<v-col cols="6" md="4">
					<v-row  >
						<v-col cols="12" md="12" class="py-0 px-2">
							<label>{{$lang.RETAILER_TYPE}}</label>
							<v-radio-group v-model="retailer_type" row :disabled="is_edit">
								<v-radio :label="$keys.REGISTERED_RETAILER" :value="$keys.REGISTERED_RETAILER"></v-radio>
								<v-radio :label="$keys.UNREGISTERED_RETAILER" :value="$keys.DUMMY_RETAILER"></v-radio>
							</v-radio-group>

						</v-col>
						<v-col cols="12" md="12" class="py-0 px-2">
							<label>{{$lang.FIRM_NAME}}</label>
							<v-text-field
							:placeholder="$lang.FIRM_NAME"
							v-model="form.retailer_firm_name"
							single-line
							outlined
							dense
							maxlength="300"
							:rules="$rules.firmNameRule"
							></v-text-field>
						</v-col>
						<v-col cols="12" md="12" class="py-0 px-2" v-if="retailer_type==$keys.REGISTERED_RETAILER">
							<label>{{$lang.MOBILE_NO}}</label>
							<v-text-field
							:placeholder="$lang.MOBILE_NO"
							v-model="form.retailer_mobile_number"
							single-line
							outlined
							dense
							maxlength="10"
							:rules="$rules.mobileRule"
							></v-text-field>
						</v-col>

						<v-col cols="12" md="12" class="py-0 px-2" v-if="retailer_type==$keys.REGISTERED_RETAILER">
							<label>{{$lang.LANDLINE_NO}}</label>
							<v-text-field
							:placeholder="$lang.LANDLINE_NO"
							v-model="form.retailer_landline_number"
							single-line
							outlined
							dense
							maxlength="11"
							:error-messages="(form.retailer_landline_number)&&(form.retailer_mobile_number==form.retailer_landline_number)?$messages.MATCHING_PHONE_NUMBER_ERROR:''"
							:rules="$rules.landlineNumberRule"
							></v-text-field>
						</v-col>
						<v-col cols="12" md="12" class="py-0 px-2" v-if="retailer_type==$keys.REGISTERED_RETAILER">
							<label>{{$lang.EMAIL_ID}}</label>
							<v-text-field
							:placeholder="$lang.EMAIL_ID"
							v-model="form.retailer_email"
							single-line
							outlined
							dense
							maxlength="50"
							:rules="$rules.emailRule"
							></v-text-field>
						</v-col>
						<v-col cols="12" md="12" class="py-0 px-2" v-if="retailer_type==$keys.REGISTERED_RETAILER">
							<label>{{$lang.SHOP_NO}}</label>
							<v-text-field
							:placeholder="$lang.SHOP_NO"
							v-model="form.retailer_shop_number"
							single-line
							outlined
							maxlength="50"
							dense
							></v-text-field>
						</v-col>

						<v-col cols="12" md="12" class="py-0 px-2">
							<label>{{$lang.PIN_CODE}}</label>
							<v-text-field
							:placeholder="$lang.PIN_CODE"
							v-model="form.retailer_pincode"
							single-line
							outlined
							dense
							maxlength="6"
							:rules="$rules.pinCodeRule"
							></v-text-field>
						</v-col>

						<v-col cols="12" md="12" class="py-0 px-2">
							<label>{{$lang.AREA}}</label>
							<v-text-field
							:placeholder="$lang.AREA"
							v-model="form.retailer_location"
							single-line
							outlined
							dense
							maxlength="100"
							:rules="$rules.AREA"
							></v-text-field>
						</v-col>

						<v-col cols="12" md="12" class="py-0 px-2">
							<label>{{$lang.CITY}}</label>
							<v-select
							v-model="form.city"
							:items="city_list"
							item-text="city_name"
							item-value="city_name"
							:placeholder="$lang.CITY"
							@focus="cityAutoComplete"
							@keydown="cityAutoComplete"
							@change="setState"
							append-icon="mdi-menu-down"
							single-line
							outlined
							dense
							return-object
							:rules="$rules.cityRule"
							:loading="city_loading"
							>
							<template v-slot:selection="{ item}">
								{{ item.city_name }}, {{ item.state_name }}								
							</template>
							<template v-slot:item="data">
								<v-list-item-content>
									<v-list-item-title v-html="data.item.city_name"></v-list-item-title>
									<v-list-item-subtitle >{{data.item.state_name}}</v-list-item-subtitle>
								</v-list-item-content>
							</template>
						</v-select>
					</v-col>
					<v-col cols="12" md="12" class="py-0 px-2">
						<label>{{$lang.FULL_ADDRESS}}</label>
						<v-textarea
						clearable
						:placeholder="$lang.FULL_ADDRESS"
						v-model="form.retailer_full_address"
						single-line
						outlined
						dense
						auto-grow
						rows="2"
						:rules="$rules.fullAddressRule"
						></v-textarea>
					</v-col> 

				</v-row>
			</v-col>
			<!-- BLANK DATA -->
			<v-col cols="6" md="1" class="border-r large-screen">
			</v-col>
			<!--  -->
			<v-col cols="6" md="5">
				<v-row  class="pl-10" >
					<v-col cols="12" md="11" class="py-0 px-2" v-if="retailer_type==$keys.REGISTERED_RETAILER">
						<label>{{$lang.GST_NUMBER}}</label>
						<v-text-field
						:placeholder="$lang.GST_NUMBER"
						v-model="form.retailer_gst_number"
						single-line
						outlined
						dense
						maxlength="15"
						:rules="$rules.gstNumberRule"
						></v-text-field>
					</v-col>
					<v-col cols="12" md="11" class="py-0 px-2">
						<label>{{$lang.LINE}}</label>
						<line-select-box  @update-line="getLine"  ref="line_data" />
					</v-col>
					<v-col cols="6" md="11" class="py-0 px-2" v-if="retailer_type==$keys.REGISTERED_RETAILER">
						<div>
							<label>{{$lang.ADD_A_PHOTO_OF_SHOP_FRONT}}</label>
							<div v-if="form.retailer_image">
								<img :src="form.retailer_image" alt="img" class="pre-image ">
								<v-btn fab width="16px" height="16px" color="#FFF"
								@click="form.retailer_image=null"
								class="v-align-top"
								style="margin-left: -10px;margin-top: -5px"
								>
								<v-icon size="10" color="error"> mdi-window-close</v-icon>
							</v-btn>
						</div>

						<file-upload-field v-if="!form.retailer_image" @update-image="changeImageFile" :file_input_label="$lang.UPLOAD_AN_IMAGE"/>
					</div>
					<div>

					</div>
				</v-col>
				<v-col cols="10" md="11" class="py-0 px-2">
					<Map class="mt-5"  @update="getLatLong"  ref="map_elm"/>

					<p v-if="location_error">
						<small class="error-text" >{{$messages.SLELECT_LOCATION}}</small>
					</p>
				</v-col>
				<v-col cols="10" md="11" class="py-0 px-2">
					<v-btn color="primary" class="signup-btn-style mt-12 px-6" @click="addRetailer()" :loading="btn_loading">
						<b>Continue</b>
					</v-btn>
				</v-col>
			</v-row>
		</v-col>
	</v-row>
</v-form>

</div>
</template>
<script type="text/javascript">

export default{
	components:{
		FileUploadField: () => import('@/components/common-components/FileUploadField.vue'),
		LineSelectBox: () => import('@/components/common-components/LineSelectBox.vue'),
      Map :()=>import('@/components/common-components/google-map/GoogleMap.vue'),
	},
	data(){
		return{
			is_edit:false,
			location_error:false,
			retailer_id:"",
			retailer_type:"Registered",
			form:{
				retailer_firm_name:"",
				retailer_mobile_number:"",
				retailer_landline_number:"",
				retailer_email:"",
				retailer_full_address:"",
				retailer_shop_number:"",
				retailer_pincode:"",
				retailer_location:"",
				city:"",
				state:"",
				retailer_gst_number:"",
				line:"",
				retailer_latitude:"",
				retailer_longitude:"",
				image:null,
				retailer_image:"",
			},
			btn_loading:false,
			
			city_loading:false,
			city_list:[],
			latlong:{},


		}
	},
	created(){
		if(this.$route.name=="edit-retailer")	{
			this.is_edit=true
			this.retailer_id= this.decrypt(this.$route.params.retailer_id)
			this.getRetailerDetails()	
		}
		this.cityAutoComplete()
	},
	methods:{
		
		/* catch the image file*/
		changeImageFile(file){
			this.form.image=file
		},
		getLine(line){
			this.form.line=line
		},
		getLatLong(latlong){
			this.location_error=false
		},
		/* set the  selected city and state */ 
		setState(item){
			if(item){
				this.form.state=item.state_name
				this.$emit('get-state',item.state_name)
			}		
			else
				this.form.state=""
		},

		/*  Add Edit Retailer  */ 	
		addRetailer(){
			const self=this

			if(!(self.$store.state.map_center.lat && self.$store.state.map_center.lng)){
				this.location_error=true
				return false
			}

			if (this.$refs.add_retailer_form.validate()==false)
				return false

			self.btn_loading=true
			console.log(self.form)
			var	form = new FormData();

			form.append("retailer_type",self.retailer_type)
			form.append("retailer_firm_name",self.form.retailer_firm_name)
			if (self.retailer_type==self.$keys.REGISTERED_RETAILER){
				form.append("retailer_mobile_number",self.form.retailer_mobile_number)
				form.append("retailer_landline_number",self.form.retailer_landline_number)
				form.append("retailer_email",self.form.retailer_email)
				form.append("retailer_shop_number",self.form.retailer_shop_number)
				form.append("retailer_gst_number",self.form.retailer_gst_number)
				form.append("retailer_image",self.form.image)
			}

			form.append("retailer_full_address",self.form.retailer_full_address)
			form.append("retailer_pincode",self.form.retailer_pincode)
			form.append("retailer_location",self.form.retailer_location)
			form.append("retailer_city",self.form.city)
			if (self.form.city.city_name)
				form.append("retailer_city",self.form.city.city_name)
			form.append("retailer_state",self.form.state)
			form.append("line_id",self.form.line.id)

			form.append("retailer_longitude",self.$store.state.map_center.lng)
			form.append("retailer_latitude",self.$store.state.map_center.lat)
			// form.append("retailer_longitude",self.form.retailer_longitude)
			// form.append("retailer_latitude",self.form.retailer_latitude)


			let url=this.$urls.REGISTER_RETAILER
			if(self.is_edit){
				url=this.$urls.EDIT_RETAILER
				form.append("retailer_id",self.retailer_id)
			}
			const successHandler = (response) => {
				if (response.data.success){
					if(response.data.flag_user_exists){
						this.$store.dispatch('snackbar/setSnackbar', {flag:true, text:response.data.message, color:'error' })
					}
					if (self.is_edit)
						self.$router.push({name:'retailer-details',params:{retailer_id:self.encript(self.retailer_id)}})
					else
						self.$router.push({name:'retailer-details',params:{retailer_id:self.encript(response.data.data.retailer_id)}})
				}
			};
			const finallyHandler = () => {
				self.btn_loading=false
			};

			this.request_POST(self,url,form,successHandler,null,null,finallyHandler)

		},
		/* fetch retailer details  for the  edit data */ 
		getRetailerDetails(){
			const self=this
			let params={
				retailer_id:self.retailer_id
			};
			self.table_loading=true

			const successHandler = (response) => {
				if (response.data.success){
					this.form=response.data.data

					self.form.city={
						city_name:response.data.data.retailer_city,
						state_name:response.data.data.retailer_state
					}

					this.$refs.map_elm.center={
						lat:parseFloat(response.data.data.retailer_latitude),
						lng:parseFloat(response.data.data.retailer_longitude)
					}

					this.$store.dispatch('setMapCenter', this.$refs.map_elm.center)

					setTimeout(()=>{
						this.$refs.map_elm.map.setZoom(15);
						
						this.$refs.line_data.selected_line={
							id:response.data.data.line_id,
							line_name:response.data.data.line_name
						}
						this.form.line={
							id:response.data.data.line_id,
							line_name:response.data.data.line_name
						}

					},400);

					if(!self.form.retailer_mobile_number)
						self.retailer_type=this.$keys.DUMMY_RETAILER
				}
			};
			const finallyHandler = () => {
				self.table_loading=false
				this.$store.dispatch('setPageLoader', false)
			};

			self.request_GET( self,self.$urls.RETAILER_PROFILE,params,successHandler,null,null,finallyHandler)
		},
	}

}

</script>